<template>
  <div>
    <ais-configure
      :filters="categoryFilter"
      :hits-per-page.camel="hitsPerPageConfiguration"
      :click-analytics.camel="true"
    />
    <ais-state-results
      v-slot="{ results: { hits, query }, status }"
      class="sticky -top-12 z-10 pb-[5px] bg-EXPONDO-white lg:static lg:bg-transparent lg:z-0 lg:p-0 lg:top-0"
    >
        <SearchResultsTop
          :hits="hits"
          :query="query"
          :status="status"
          :category-filter="categoryFilter"
          :description="description"
        />
    </ais-state-results>
    <div class="flex gap-2">
      <FilterModal class="lg:w-80" />
      <ais-state-results
        v-slot="{ results: { hits, query }, status }"
        class="w-full"
      >
        <SearchResultsInner
          :hits="hits"
          :query="query"
          :status="status"
          :category-filter="categoryFilter"
          :product-group-items="productGroupItems"
          :product-group-items-text-color="productGroupItemsTextColor"
          :product-group-items-background-color="productGroupItemsBackgroundColor"
          @product-listing-shown="(products) => $emit('product-listing-shown', products)"
        />
      </ais-state-results>
    </div>
  </div>
</template>

<script lang="ts">

import {
  AisConfigure,
  AisStateResults,
} from 'vue-instantsearch/vue3/es';

import type { ProductGroupsItemType } from '~~/types/cms/ProductGroupsItem';

import { HITS_PER_PAGE_ITEMS, TYPESENSE_ATTRIBUTE, MAX_STARS } from '~~/constants/typesense';

export default defineComponent({
  name: 'SearchResults',
  components: {
    AisConfigure,
    AisStateResults,
  },
  props: {
    categoryFilter: {
      type: String,
      default: '',
    },
    enableStateMapping: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: '',
    },
    productGroupItems: {
      type: Array as PropType<Array<ProductGroupsItemType>>,
      default: () => [],
    },
    productGroupItemsTextColor: {
      type: String,
      default: 'text-EXPONDO-black',
    },
    productGroupItemsBackgroundColor: {
      type: String,
      default: 'bg-EXPONDO-grey-5',
    },
  },
  emits: ['product-listing-shown'],
  setup() {

    const { hitsPerPageConfiguration } = useTypesense();

    HITS_PER_PAGE_ITEMS.forEach(config => {

      config.default = config.value === hitsPerPageConfiguration.value;

    });

    return {
      hitsPerPageConfiguration,
      TYPESENSE_ATTRIBUTE,
      MAX_STARS,
    };

  },
});

</script>
